import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './AdminSecurityComponent.css';
import _ from 'lodash';
import { Table, Button } from 'reactstrap';
import GlobalCertificates from '../../organizationManagement/certificatesManagement/globalCertificates/GlobalCertificates.container';
import PaginationOrgsWithoutCertificates from '../../commonComponents/paginationComponent/PaginationOrgsWithoutCertificates.container';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import AddOrgFirstCertificateModal from '../../organizationManagement/certificatesManagement/addCertificateModal/AddOrgFirstCertificateModal.container';
import moment from 'moment';

const NEW_LINE_ELEM = "\r\n";

class AdminSecurityComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            orgId: null,
            isConfirmButtonEnabledData: {}
        }
    }

    componentDidMount() {
        this.props.onMount();
    }

    render() {
        return (
            <div className='admin-security-container'>
                <h4 className='page-label'>
                    {_.get(this.props.translation, 'security.label')}
                </h4>
                <h5 className="admin-security-subtitle olive-green">
                    {_.get(this.props.translation, 'security.admin_root_certificates_label')}
                </h5>
                <GlobalCertificates />
                <h5 className="admin-security-subtitle olive-green">
                    {_.get(this.props.translation, 'security.admin_universities_label')}
                </h5>
                <div className="admin-security-info-container">
                    <h6>{_.get(this.props.translation, 'security.admin_universities_info_part_1')}</h6>
                    <h6>{_.get(this.props.translation, 'security.admin_universities_info_part_2')}</h6>
                </div>
                <PaginationOrgsWithoutCertificates />
                {this.renderOrgsTable()}
                <AddOrgFirstCertificateModal orgId={this.state.orgId} />
            </div>
        );
    }

    renderOrgsTable = () => {
        if (this.props.loading) {
            return (
                <div className="org-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="org-status-message-container">
                    <h5>{_.get(this.props.translation, 'orgs.no_data_label')}</h5>
                </div>
            );
        }
        return (
            <Table className='orgs-table'>
                <thead>
                    <tr>
                        <th>{_.get(this.props.translation, 'orgs.org_label')}</th>
                        <th>{_.get(this.props.translation, 'orgs.anchor_label')}</th>
                        <th>{_.get(this.props.translation, 'security.add_valid_till_label')}</th>
                        <th></th>
                        <th>{_.get(this.props.translation, 'security.is_uni_key_sent_label')}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderOrgsData()}
                </tbody>
            </Table>
        );
    };

    renderOrgsData = () => {
        return _.map(this.props.data, (orgData, index) => (
            <tr className="orgs-table-row" key={index}>
                <td
                    className='org-name-td'
                    data-th={_.get(this.props.translation, 'orgs.org_label') + ":"}
                >
                    {orgData.orgName}
                </td>
                <td
                    className='anchor-td'
                    data-th={_.get(this.props.translation, 'orgs.anchor_label') + ":"}
                >
                    <div>{orgData.anchorName + '\n'}</div>
                    <a onClick={this.handleMailtoLinkClick} href={"mailto:" + orgData.anchorEmail}>{orgData.anchorEmail}</a>
                </td>
                <td
                    className='add-valid-till-td'
                    data-th={_.get(this.props.translation, 'security.add_valid_till_label') + ":"}
                >
                    {
                        this.props.certificatesData && this.props.certificatesData[orgData.id] ?
                            moment(this.props.certificatesData[orgData.id].validTill).format("MMMM Do YYYY, HH:mm")
                            :
                            <Button
                                className="olive-green-btn"
                                onClick={this.onAddCertificateButtonClick(orgData.id)}
                                size="sm"
                            >
                                {_.get(this.props.translation, 'security.add_certificate_button')}
                            </Button>
                    }
                </td>
                <td className='mail-to-anchor-td'>
                    <a
                        className={`btn olive-green-btn btn-sm ${this.props.certificatesData && this.props.certificatesData[orgData.id] ? "" : "disabled"}`}
                        href={this.getMailToHref(orgData.anchorEmail, orgData.anchorName)}
                        onClick={this.onMailAnchorButtonClick(orgData.id)}
                    >
                        {_.get(this.props.translation, 'security.mail_anchor_label')}
                    </a>
                </td>
                <td className='confirm-mail-to-anchor-td'>
                    <Button
                        className="olive-green-btn"
                        onClick={this.onConfirmSentButtonClick(orgData.id)}
                        disabled={!this.state.isConfirmButtonEnabledData[orgData.id]}
                        size="sm"
                    >
                        {_.get(this.props.translation, 'security.confirm_sent_button')}
                    </Button>
                </td>
            </tr>
        ));
    };

    getMailToHref = (anchorEmail, anchorName) => {
        let str = "mailto:" + anchorEmail + "?subject=" + _.get(this.props.translation, 'security.mail_subject_label') +
            "&body=" + _.get(this.props.translation, 'security.mail_body_part_1').replace('{anchor}', anchorName) +
            NEW_LINE_ELEM + NEW_LINE_ELEM +
            _.get(this.props.translation, 'security.mail_body_part_2') +
            NEW_LINE_ELEM + NEW_LINE_ELEM +
            _.get(this.props.translation, 'security.mail_body_part_3') +
            NEW_LINE_ELEM + NEW_LINE_ELEM +
            _.get(this.props.translation, 'security.mail_body_part_4') +
            NEW_LINE_ELEM + NEW_LINE_ELEM +
            _.get(this.props.translation, 'security.mail_body_part_5') +
            NEW_LINE_ELEM + NEW_LINE_ELEM +
            _.get(this.props.translation, 'security.mail_body_part_6');

        return encodeURI(str);
    }

    onAddCertificateButtonClick = (orgId) => () => {
        this.setState({ orgId: orgId });
        this.props.onAddCertificate();
    }

    onMailAnchorButtonClick = (orgId) => () => {
        let data = _.cloneDeep(this.state.isConfirmButtonEnabledData);
        data[orgId] = true;
        this.setState({ isConfirmButtonEnabledData: data });
    }

    onConfirmSentButtonClick = (orgId) => () => {
        this.props.onConfirmSent(orgId);
    }
}

AdminSecurityComponent.propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.array,
    certificatesData: PropTypes.object,
    translation: PropTypes.object.isRequired,
    onMount: PropTypes.func.isRequired,
    onAddCertificate: PropTypes.func.isRequired,
    onConfirmSent: PropTypes.func.isRequired
};

export default AdminSecurityComponent;


// WEBPACK FOOTER //
// ./src/components/securityManagement/adminSecurityComponent/AdminSecurityComponent.js